import type { RouteObject } from 'react-router-dom';

import { SessionProvider } from '@/features/session/SessionProvider';
import { AuthDonePage } from '@/features/session/components/AuthDonePage';
import { SessionGate } from '@/features/session/components/SessionGate';
import { EmbedPage } from '@/pages/Embed/EmbedPage';
import { GasbiAiPage } from '@/pages/GasbiAi/GasbiAiPage';
import { McpConnectedPage } from '@/pages/McpConnected/McpConnectedPage';

import { Stack } from '@mui/joy';

// ADR-0004 §2.1: the full page, the panel the launcher frames, the end of the sign-in window (no session gate: it is
// the window itself). The panel keeps its header above the gate, so it puts the gate below it on its own.
// §2.10: the end of connecting an external MCP server from the Admin catalog, no session gate either: the flow is over,
// the page only reports how it ended (PO, 2026-10-12).
export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <SessionProvider mode='page'>
        <Stack sx={{ height: '100dvh' }}>
          <SessionGate>
            <GasbiAiPage />
          </SessionGate>
        </Stack>
      </SessionProvider>
    ),
  },
  {
    path: '/embed',
    element: (
      <SessionProvider mode='embed'>
        <EmbedPage />
      </SessionProvider>
    ),
  },
  { path: '/auth/done', element: <AuthDonePage /> },
  { path: '/mcp/connected', element: <McpConnectedPage /> },
];
